export const CFormieFragments = {
  field: `
    fragment FormieFormFragment on FormInterface {
        id
        title
        handle
        siteId
        csrfToken {
            name
            value
        }
        captchas {
            handle
            name
            value
        }
        pages {
            # Formie 3 renamed page "name" to "label"
            name: label
            id
            settings {
                submitButtonLabel
                backButtonLabel
                showBackButton
                buttonsPosition
            }
            rows {
                rowFields {
                    ...FormieFieldFragment
                    ... on Field_Repeater {
                        fields {
                            ...FormieFieldFragment
                        }
                    }
                    ... on Field_Group {
                        fields {
                            ...FormieFieldFragment
                        }
                    }
                }
            }
        }
    }
    fragment FormieFieldFragment on FieldInterface {
        id
        # Formie 3 renamed field "name" to "label"
        name: label
        label
        handle
        instructions
        required
        type
        displayName
        typeName
        inputTypeName
        placeholder
        errorMessage
        labelPosition
        instructionsPosition
        cssClasses
        enableConditions
        conditions
        enableContentEncryption
        visibility
        containerAttributes {
            label
            value
        }
        inputAttributes {
            label
            value
        }
        ... on Field_Agree {
            defaultState
            checkedValue
            uncheckedValue
            descriptionHtml
        }
        ... on Field_Dropdown {
            defaultValue
            options {
                label
                value
            }
        }
        ... on Field_Email {
            defaultValue
        }
        ... on Field_MultiLineText {
            defaultValue
        }
        ... on Field_SingleLineText {
            defaultValue
        }
        ... on Field_Html {
            htmlContent
        }
    }
  `,
}
